// Date 2021-03-19 18:47:32

import sithMesStoolVendor from "@/store/sithMes/stool/SithMesStoolVendorStore.js";
import sithMesStoolPr from "@/store/sithMes/stool/SithMesStoolPrStore.js";
import sithMesStoolPrPoList from "@/store/sithMes/stool/SithMesStoolPrPoListStore.js";
import sithMesStoolPo from "@/store/sithMes/stool/SithMesStoolPoStore.js";
import sithMesStoolProblematicPr from "@/store/sithMes/stool/SithMesStoolProblematicPrStore.js";
import sithMesStoolPrPrice from "@/store/sithMes/stool/SithMesStoolPrPriceStore.js";
import sithMesStoolDeliverList from "@/store/sithMes/stool/SithMesStoolDeliverListStore.js";
import sithMesStoolDeliverTask from "@/store/sithMes/stool/SithMesStoolDeliverTaskStore.js";
import sithMesStool26Stock from "@/store/sithMes/stool/SithMesStool26StockStore.js";
import sithMesStoolGrn from "@/store/sithMes/stool/SithMesStoolGrnStore.js";
import sithMesStoolPoSdr from "@/store/sithMes/stool/SithMesStoolPoSdrStore.js";
import sithMesStool26StockTransfer from "@/store/sithMes/stool/SithMesStool26StockTransferStore.js";
import sithMesStoolExternalInspection from "@/store/sithMes/stool/SithMesStoolExternalInspectionStore";
import sithMesStoolRequireDateChangeHistory from "@/store/sithMes/stool/SithMesStoolRequireDateChangeHistoryStore.js";
import sithMesStoolPurchasingGroup from "@/store/sithMes/stool/SithMesStoolPurchasingGroupStore";
import sithMesStoolTransferTicketGenerationRecord from "@/store/sithMes/stool/SithMesStoolTransferTicketGenerationRecordStore";
import sithMesStoolTransferTicketDetail from "@/store/sithMes/stool/SithMesStoolTransferTicketDetailStore";
import sithMesStoolPrApplicationIndirectPurchaseDetail from "@/store/sithMes/stool/SithMesStoolPrApplicationIndirectPurchaseDetailStore.js";
import sithMesStoolPrApplicationShippingDetail from "@/store/sithMes/stool/SithMesStoolPrApplicationShippingDetailStore.js";
import sithMesStoolPrApplicationTypeConfig from "@/store/sithMes/stool/SithMesStoolPrApplicationTypeConfigStore.js";
import sithMesStoolPrApplicationRecord from "@/store/sithMes/stool/SithMesStoolPrApplicationRecordStore.js";


const genericEntities = [
    'sithMesStoolVendor',
    'sithMesStoolPr',
    'sithMesStoolPrPoList',
    'sithMesStoolPo',
    'sithMesStoolProblematicPr',
    'sithMesStoolPrPrice',
    'sithMesStoolDeliverList',
    'sithMesStool26Stock',
    'sithMesStoolGrn',
    'sithMesStoolDeliverTask',
    'sithMesStoolPoSdr',
    'sithMesStool26StockTransfer',
    'sithMesStoolExternalInspection',
    'sithMesStoolRequireDateChangeHistory',
    'sithMesStoolPurchasingGroup',
    'sithMesStoolTransferTicketGenerationRecord',
    'sithMesStoolTransferTicketDetail',
    'sithMesStoolPrApplicationIndirectPurchaseDetail',
    'sithMesStoolPrApplicationShippingDetail',
    'sithMesStoolPrApplicationTypeConfig',
    'sithMesStoolPrApplicationRecord'
]

const entities = {
    sithMesStoolVendor,
    sithMesStoolPr,
    sithMesStoolPrPoList,
    sithMesStoolPo,
    sithMesStoolProblematicPr,
    sithMesStoolPrPrice,
    sithMesStoolDeliverList,
    sithMesStool26Stock,
    sithMesStoolDeliverTask,
    sithMesStoolGrn,
    sithMesStoolPoSdr,
    sithMesStool26StockTransfer,
    sithMesStoolExternalInspection,
    sithMesStoolRequireDateChangeHistory,
    sithMesStoolPurchasingGroup,
    sithMesStoolTransferTicketGenerationRecord,
    sithMesStoolTransferTicketDetail,
    sithMesStoolPrApplicationIndirectPurchaseDetail,
    sithMesStoolPrApplicationShippingDetail,
    sithMesStoolPrApplicationTypeConfig,
    sithMesStoolPrApplicationRecord
}

export {genericEntities}


export default entities
